import logoUrl from "@/assets/logos/logo_scada_automation.svg";
import sinusUrl from "@/assets/logos/SCADA-Automation_Sinuskurve_blau_CMYK.svg";

export function PlainNavbar() {
	return (
		<header>
			<div className="navbar-wrap">
				<nav className="navbar">
					{/* Logo */}
					<a href="/" className="logo">
						<img src={logoUrl} alt="Scada Automation Logo" height={40} />
					</a>

					{/* Burger Toggle */}
					<input type="checkbox" id="menu-toggle" />
					<label htmlFor="menu-toggle" className="menu-icon">
						<span />
						<span />
						<span />
					</label>

					{/* Navigation */}
					<div className="menu-container">
						<ul className="menu">
							<li>
								<a href="https://scada-automation.com/">
									<img className="home-icon" src={sinusUrl} alt="" />
									Home
								</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</header>
	);
}
